import { createFileRoute } from '@tanstack/react-router';
import { VerifyPage } from '@/components/verify/VerifyPage';

export const Route = createFileRoute('/verify/$tagToken')({
  component: VerifyTagTokenPage,
});

function VerifyTagTokenPage() {
  const { tagToken } = Route.useParams();
  return <VerifyPage pathToken={tagToken} />;
}
